import { appEntry } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-cinema-card via-cinema-card to-cinema-gold/5 border border-cinema-border rounded-xl p-6 md:p-10">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">{appEntry.title}</h2>
            <p className="text-sm text-cinema-text-dim mb-6">{appEntry.subtitle}</p>
            <ul className="space-y-3 mb-8">
              {appEntry.features.map((f, i) => (
                <li key={i} className="flex items-center gap-3 justify-center lg:justify-start text-sm text-cinema-text-dim">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-cinema-gold text-sm"></i>
                  </div>
                  {f}
                </li>
              ))}
            </ul>
            <a
              href="#about"
              className="inline-flex items-center gap-2 px-8 py-3 bg-cinema-gold hover:bg-cinema-gold-dark text-cinema-bg font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              {appEntry.downloadLabel}
            </a>
          </div>

          <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-cinema-gold/10 via-cinema-accent/10 to-cinema-gold/10 rounded-2xl blur-lg"></div>
              <div className="relative bg-cinema-surface border border-cinema-border rounded-xl overflow-hidden">
                <img
                  src={appEntry.imageUrl}
                  alt="黄瓜影院APP界面截图"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}